import React from "react";
import { Button, Typography } from "@plum-xoxo/admin-dsm";
import EditMask from "./EditMask";

const XoxoLinkRewardBody = ({
  selectedValue,
  validTill,
  currencyCode,
  toggleTextModal,
  buttonText,
}) => {
  return (
    <>
      <div className="text-center">
        <Typography.BodySmall className="mb-8" color="dark" shade="c200">
          Reward Link worth
        </Typography.BodySmall>
        <Typography.DisplayText color="dark" shade="c300" component="div">
          {currencyCode} ***
        </Typography.DisplayText>
        <div className="position-relative">
          <Button size="large" className="w-100 my-16">
            {buttonText}
          </Button>
          <EditMask
            buttonText="Button Text"
            top={0}
            toggleModalState={() => toggleTextModal()}
          />
        </div>
        <Typography.BodySmall color="dark" shade="c200" component="div">
          Expires on {validTill}
        </Typography.BodySmall>
      </div>
    </>
  );
};

export default XoxoLinkRewardBody;
